import React from "react";
import { cx } from "../utils";

const VARIANT_CLASS = {
  ghost: "cc-icon-button--ghost",
  secondary: "cc-icon-button--secondary",
  primary: "cc-icon-button--primary",
  danger: "cc-icon-button--danger",
  ai: "cc-icon-button--ai",
};

const SIZE_CLASS = {
  sm: "cc-icon-button--sm",
  small: "cc-icon-button--sm",
  subTab: "cc-icon-button--sub-tab",
};

/**
 * Carecentre Zen icon button — styles from tokens.css (.cc-icon-button--*).
 * Variants: ghost, secondary, primary, danger, ai.
 */
const CcIconButton = ({
  label,
  variant = "ghost",
  size = "md",
  className,
  children,
  type = "button",
  ...props
}) => {
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.ghost;
  const sizeClass = SIZE_CLASS[size] || null;

  return (
    <button
      type={type}
      aria-label={label}
      title={label}
      className={cx("cc-icon-button", variantClass, sizeClass, className)}
      {...props}
    >
      {children}
    </button>
  );
};

export default CcIconButton;
